import { t } from "@lingui/macro";
import {
  BudgetItemTypeEnum,
  PaymentStatusEnum,
} from "@src/__generated__/graphql";
import type { IOption } from "@src/components/ui-kit";
import { appStore } from "@src/stores/AppStore";

export function getBooleanFilterOptions(): IOption[] {
  return [
    { label: t`Yes`, value: "true" },
    { label: t`No`, value: "false" },
  ];
}

export function getPaymentStatusFilterOptions(): IOption[] {
  if (appStore.workspaceStore.settings?.enableBank) {
    return [
      { value: PaymentStatusEnum.Paid, label: t`Paid` },
      { value: PaymentStatusEnum.NotPaid, label: t`Unpaid` },
      { value: PaymentStatusEnum.PartiallyPaid, label: t`Partially paid` },
    ];
  }

  return [
    { value: PaymentStatusEnum.Paid, label: t`Paid` },
    { value: PaymentStatusEnum.NotPaid, label: t`Unpaid` },
  ];
}

export function getBudgetItemTypeFilterOptions(): IOption[] {
  return [
    { value: BudgetItemTypeEnum.OurWorkBudgetItem, label: t`Work` },
    { value: BudgetItemTypeEnum.ExpenseBudgetItem, label: t`Expense` },
  ];
}
